import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CopyToClipboardDirective } from '@shared/ui';

import { VehiclesDetailComponent } from './components';

@NgModule({
	imports: [CommonModule, TranslateModule, CopyToClipboardDirective],
	declarations: [VehiclesDetailComponent],
	exports: [VehiclesDetailComponent, CopyToClipboardDirective]
})
export class VehiclesModule {}
